<ng-container *ngIf="action$ | async"></ng-container>

<ng-container *ngIf="data$ | async as data">
  <div id="cutting-result" fusePerfectScrollbar *ngIf="data.result" class="w-full h-full flex flex-col items-stretch">
    <div class="m-4 flex flex-row space-x-4 items-center">
      <mat-form-field appearance="outline" class="dense-input no-subscript w-50-p">
        <mat-select
          i18n-placeholder
          placeholder="Материал ({{ data.result.length }} шт)"
          #materialSelect
          [value]="data.result.length ? data.result[0] : undefined">
          <mat-option *ngFor="let item of data.result" [value]="item">
            {{ getMaterialName(item) }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <button
        mat-icon-button
        i18n-matTooltip
        matTooltip="Статистика по материалу"
        (click)="openMaterialStatistic(materialSelect.value)"
        *ngIf="showCuttedMaterialStatistic && materialSelect.value">
        <mat-icon>info_outline</mat-icon>
      </button>
    </div>

    <mat-divider> </mat-divider>

    <mat-tab-group mat-stretch-tabs dynamicHeight *ngIf="showSubTabs && data.result?.length" fusePerfectScrollbar>
      <mat-tab *ngIf="showCuttingMaps">
        <ng-template mat-tab-label>
          <div class="flex flex-row space-x-2 justify-center items-center">
            <div>
              <mat-icon>view_quilt</mat-icon>
            </div>
            <div i18n>Карты раскроя</div>
          </div>
        </ng-template>

        <div class="p-4 w-full h-full" fusePerfectScrollbar>
          <cutting-cutting-maps
            *ngIf="!achivedOrder; else achivedOrderTemplate"
            fusePerfectScrollbar
            [materialId]="materialSelect.value?.inMaterialBaseId">
          </cutting-cutting-maps>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex flex-row space-x-2 justify-center items-center">
            <div>
              <mat-icon>tab_unselected</mat-icon>
            </div>
            <div i18n>Обрезки</div>
          </div>
        </ng-template>

        <div class="p-4 flex flex-row space-x-6 items-stretch">
          <div class="fuse-card flex flex-col items-stretch flex-1">
            <p i18n class="mat-body-2 mx-6 my-2">Обрезки, используемые для раскроя</p>

            <mat-divider> </mat-divider>

            <cutting-used-client-offcuts fusePerfectScrollbar [material]="materialSelect.value">
            </cutting-used-client-offcuts>
          </div>
          <div class="fuse-card flex flex-col items-stretch flex-1">
            <p i18n class="mat-body-2 mx-6 my-2">Обрезки, полученные при раскрое</p>

            <mat-divider> </mat-divider>

            <cutting-offcut-list
              fusePerfectScrollbar
              [canTakeAway]="canTakeAwayOffcuts(materialSelect.value?.inMaterialBaseId, data.result).canTakeAwayOffcuts"
              [material]="materialSelect.value">
            </cutting-offcut-list>
          </div>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex flex-row space-x-2 justify-center items-center" data-testid="panels-schema-tab">
            <div>
              <mat-icon>vertical_split</mat-icon>
            </div>
            <div i18n>Чертежи панелей</div>
          </div>
        </ng-template>

        <ng-container *ngIf="!achivedOrder; else achivedOrderTemplate">
          <csl-panels-schema
            *ngIf="linkToPanelsSchema"
            [linkToSchemas]="linkToPanelsSchema | async"
            [data]="{
              materialId: materialSelect.value?.inMaterialBaseId,
              panels: materialSelect.value?.panels,
              selectedPanelUuid: undefined
            }"
            class="flex-1">
          </csl-panels-schema>
        </ng-container>
      </mat-tab>

      <ng-template #achivedOrderTemplate>
        <div class="p-6 mat-title accent-fg">
          <div class="flex flex-row space-x-2 items-center">
            <!-- <div> -->
            <mat-icon>info_outline</mat-icon>
            <!-- </div> -->
            <div i18n>Для просмотра необходимо извлечь заказ из архива</div>
          </div>
        </div>
      </ng-template>
    </mat-tab-group>
  </div>

  <div *ngIf="!data.result && !data.error">Loading…</div>

  <div *ngIf="data.error">
    {{ data.error }}
  </div>
</ng-container>
